/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import {I18n} from '../model/i18n';
import {I18nDTO} from '../model/i18nDTO';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';
import {FsTranslate} from '../model/fsTranslate';
import {I18nFile} from '../model/i18nFile';
import {I18nFsTranslate} from '../model/i18nFsTranslate';
import {I18nString} from '../model/i18nString';
import {Pageable} from '../model/pageable';

@Injectable()
export class ConfiguratorI18nService {
    protected basePath = 'https://dmp.airiane.com/services/configurator';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(
        protected httpClient: HttpClient,
        @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = "multipart/form-data";
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

    /**
     * createI18n
     *
     * @param xDataStoreID X-DataStoreID
     * @param i18n i18n
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createI18nUsingPOST(xDataStoreID: string, i18n: I18n, observe?: 'body', reportProgress?: boolean): Observable<I18n>;
    public createI18nUsingPOST(xDataStoreID: string, i18n: I18n, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<I18n>>;
    public createI18nUsingPOST(xDataStoreID: string, i18n: I18n, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<I18n>>;
    public createI18nUsingPOST(xDataStoreID: string, i18n: I18n, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling createI18nUsingPOST.');
        }

        if (i18n === null || i18n === undefined) {
            throw new Error('Required parameter i18n was null or undefined when calling createI18nUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<I18n>(`${this.basePath}/api/i18ns`,
            i18n,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteI18n
     *
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteI18nUsingDELETE(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteI18nUsingDELETE(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteI18nUsingDELETE(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteI18nUsingDELETE(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling deleteI18nUsingDELETE.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteI18nUsingDELETE.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any> id);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.delete<any>(`${this.basePath}/api/i18ns`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xDataStoreID
     * @param pageable
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllI18ns(xDataStoreID: string, pageable: Pageable, observe?: 'body', reportProgress?: boolean): Observable<Array<I18nFile | I18nFsTranslate | I18nString>>;
    public getAllI18ns(xDataStoreID: string, pageable: Pageable, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<I18nFile | I18nFsTranslate | I18nString>>>;
    public getAllI18ns(xDataStoreID: string, pageable: Pageable, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<I18nFile | I18nFsTranslate | I18nString>>>;
    public getAllI18ns(xDataStoreID: string, pageable: Pageable, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getAllI18ns.');
        }

        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling getAllI18ns.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }
        if (pageable !== undefined && pageable !== null) {
            headers = headers.set('pageable', String(pageable));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<I18nFile | I18nFsTranslate | I18nString>>('get',`${this.basePath}/api/i18ns`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getByKeyStartWith
     *
     * @param xDataStoreID X-DataStoreID
     * @param group group
     * @param key key
     * @param lang lang
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getByKeyStartWithUsingGET(xDataStoreID: string, group: string, key: string, lang: string, observe?: 'body', reportProgress?: boolean): Observable<Array<I18nDTO>>;
    public getByKeyStartWithUsingGET(xDataStoreID: string, group: string, key: string, lang: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<I18nDTO>>>;
    public getByKeyStartWithUsingGET(xDataStoreID: string, group: string, key: string, lang: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<I18nDTO>>>;
    public getByKeyStartWithUsingGET(xDataStoreID: string, group: string, key: string, lang: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getByKeyStartWithUsingGET.');
        }

        if (group === null || group === undefined) {
            throw new Error('Required parameter group was null or undefined when calling getByKeyStartWithUsingGET.');
        }

        if (key === null || key === undefined) {
            throw new Error('Required parameter key was null or undefined when calling getByKeyStartWithUsingGET.');
        }

        if (lang === null || lang === undefined) {
            throw new Error('Required parameter lang was null or undefined when calling getByKeyStartWithUsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<Array<I18nDTO>>(`${this.basePath}/api/i18ns/search-startwith/${encodeURIComponent(String(lang))}/${encodeURIComponent(String(key))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getByKey
     *
     * @param xDataStoreID X-DataStoreID
     * @param group group
     * @param key key
     * @param lang lang
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getByKeyUsingGET1(xDataStoreID: string, group: string, key: string, lang: string, observe?: 'body', reportProgress?: boolean): Observable<I18nDTO>;
    public getByKeyUsingGET1(xDataStoreID: string, group: string, key: string, lang: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<I18nDTO>>;
    public getByKeyUsingGET1(xDataStoreID: string, group: string, key: string, lang: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<I18nDTO>>;
    public getByKeyUsingGET1(xDataStoreID: string, group: string, key: string, lang: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getByKeyUsingGET1.');
        }

        if (group === null || group === undefined) {
            throw new Error('Required parameter group was null or undefined when calling getByKeyUsingGET1.');
        }

        if (key === null || key === undefined) {
            throw new Error('Required parameter key was null or undefined when calling getByKeyUsingGET1.');
        }

        if (lang === null || lang === undefined) {
            throw new Error('Required parameter lang was null or undefined when calling getByKeyUsingGET1.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<I18nDTO>(`${this.basePath}/api/i18ns/search/${encodeURIComponent(String(lang))}/${encodeURIComponent(String(key))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getByLang
     *
     * @param xDataStoreID X-DataStoreID
     * @param lang lang
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getByLangUsingGET(xDataStoreID: string, lang: string, observe?: 'body', reportProgress?: boolean): Observable<Array<I18nDTO>>;
    public getByLangUsingGET(xDataStoreID: string, lang: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<I18nDTO>>>;
    public getByLangUsingGET(xDataStoreID: string, lang: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<I18nDTO>>>;
    public getByLangUsingGET(xDataStoreID: string, lang: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getByLangUsingGET.');
        }

        if (lang === null || lang === undefined) {
            throw new Error('Required parameter lang was null or undefined when calling getByLangUsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<Array<I18nDTO>>(`${this.basePath}/api/i18ns/search/${encodeURIComponent(String(lang))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getI18nGroup
     *
     * @param xDataStoreID X-DataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getI18nGroupUsingGET(xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<Array<string>>;
    public getI18nGroupUsingGET(xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<string>>>;
    public getI18nGroupUsingGET(xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<string>>>;
    public getI18nGroupUsingGET(xDataStoreID: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getI18nGroupUsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<Array<string>>(`${this.basePath}/api/i18ns/group`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getI18n
     *
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getI18nUsingGET(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<I18n>;
    public getI18nUsingGET(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<I18n>>;
    public getI18nUsingGET(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<I18n>>;
    public getI18nUsingGET(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getI18nUsingGET.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getI18nUsingGET.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any> id);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<I18n>(`${this.basePath}/api/i18n`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateI18n
     *
     * @param xDataStoreID X-DataStoreID
     * @param i18n i18n
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateI18nUsingPUT(xDataStoreID: string, i18n: I18n, observe?: 'body', reportProgress?: boolean): Observable<I18n>;
    public updateI18nUsingPUT(xDataStoreID: string, i18n: I18n, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<I18n>>;
    public updateI18nUsingPUT(xDataStoreID: string, i18n: I18n, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<I18n>>;
    public updateI18nUsingPUT(xDataStoreID: string, i18n: I18n, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateI18nUsingPUT.');
        }

        if (i18n === null || i18n === undefined) {
            throw new Error('Required parameter i18n was null or undefined when calling updateI18nUsingPUT.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<I18n>(`${this.basePath}/api/i18ns`,
            i18n,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Exporter une i18n au format JSON
     * Cette requête permet d'exporter une i18n au format JSON. (code 200)
     * @param xDataStoreID
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportI18nJson(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public exportI18nJson(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public exportI18nJson(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public exportI18nJson(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling exportI18nJson.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling exportI18nJson.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        return this.httpClient.request('get',`${this.basePath}/api/i18ns/export/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob'
            }
        );
    }

    /**
     * Exporter plusieurs i18ns au format ZIP
     * Cette requête permet d'exporter plusieurs i18ns dans une archive ZIP. (code 200)
     * @param xDataStoreID
     * @param ids
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportI18nsZip(xDataStoreID: string, ids: string[], observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public exportI18nsZip(xDataStoreID: string, ids: string[], observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public exportI18nsZip(xDataStoreID: string, ids: string[], observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public exportI18nsZip(xDataStoreID: string, ids: string[], observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling exportI18nsZip.');
        }

        if (ids === null || ids === undefined) {
            throw new Error('Required parameter ids was null or undefined when calling exportI18nsZip.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ids) {
            ids.forEach((element) => {
                queryParameters = queryParameters.append('ids', <any>element);
            })
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        return this.httpClient.request('get',`${this.basePath}/api/i18ns/export/zip`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob'
            }
        );
    }

    /**
     * Importer une i18n depuis JSON
     * Cette requête permet d'importer une i18n depuis un JSON. (code 201)
     * @param xDataStoreID
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importI18nJson(xDataStoreID: string, body: string, observe?: 'body', reportProgress?: boolean): Observable<I18n>;
    public importI18nJson(xDataStoreID: string, body: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<I18n>>;
    public importI18nJson(xDataStoreID: string, body: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<I18n>>;
    public importI18nJson(xDataStoreID: string, body: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling importI18nJson.');
        }

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling importI18nJson.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        headers = headers.set('Content-Type', 'application/json');

        return this.httpClient.request<I18n>('post',`${this.basePath}/api/i18ns/import/json`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Importer plusieurs i18ns depuis ZIP
     * Cette requête permet d'importer plusieurs i18ns depuis une archive ZIP. (code 200)
     * @param xDataStoreID
     * @param file
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importI18nsZip(xDataStoreID: string, file: Blob, observe?: 'body', reportProgress?: boolean): Observable<Array<I18n>>;
    public importI18nsZip(xDataStoreID: string, file: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<I18n>>>;
    public importI18nsZip(xDataStoreID: string, file: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<I18n>>>;
    public importI18nsZip(xDataStoreID: string, file: Blob, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling importI18nsZip.');
        }

        if (file === null || file === undefined) {
            throw new Error('Required parameter file was null or undefined when calling importI18nsZip.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        const formData = new FormData();
        formData.append('file', file);

        return this.httpClient.request<Array<I18n>>('post',`${this.basePath}/api/i18ns/import/zip`,
            {
                body: formData,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getListDialCode1(observe?: 'body', reportProgress?: boolean): Observable<Array<FsTranslate>>;
    public getListDialCode1(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<FsTranslate>>>;
    public getListDialCode1(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<FsTranslate>>>;
    public getListDialCode1(observe: any = 'body', reportProgress = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<FsTranslate>>('get',`${this.basePath}/api/i18-cache/client/dialcode/list`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
